import React, { useEffect } from "react";
import { Plane } from "@react-three/drei";
import * as THREE from "three";
import { useThree } from "@react-three/fiber";
export default function BackGrid({ zPos }) {
  const { scene } = useThree();
  useEffect(() => {
    scene.fog = new THREE.FogExp2(0, 0.1);
  }, [scene]);

  return (
    <Plane
      position={[0, zPos, -8]}
      rotation={[Math.PI / 2, 0, 0]}
      args={[80, 80, 128, 128]}
      key="grid"
    >
      <meshStandardMaterial color="grey" wireframe side={THREE.DoubleSide} />
    </Plane>
  );
}
